module.exports = __webpack_public_path__ + "static/15-2d524a5676d6b3de1e7c1ee4a972cef5.jpg";